import React, { useEffect, useState } from 'react';

const COLORS = ['#E07A3A', '#25D366', '#F59E0B', '#FFFFFF', '#FEF3EC'];

/**
 * Pure-CSS confetti burst. Trigger by incrementing the `trigger` prop.
 * Creates 30 absolutely-positioned pieces that animate outward then fade.
 */
const Confetti = ({ trigger = 0, durationMs = 1500, pieceCount = 30 }) => {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    if (trigger === 0) return;
    const batch = Array.from({ length: pieceCount }, (_, i) => ({
      id: `${trigger}-${i}`,
      color: COLORS[i % COLORS.length],
      angle: (i / pieceCount) * 360 + Math.random() * 20,
      distance: 80 + Math.random() * 120,
      delay: Math.random() * 80,
      size: 5 + Math.random() * 5,
      rot: Math.random() * 720 - 360,
    }));
    setPieces(batch);
    const t = setTimeout(() => setPieces([]), durationMs + 200);
    return () => clearTimeout(t);
  }, [trigger, pieceCount, durationMs]);

  if (pieces.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[9999] flex items-center justify-center" aria-hidden="true" data-testid="confetti-layer">
      {pieces.map(p => {
        const radians = (p.angle * Math.PI) / 180;
        const dx = Math.cos(radians) * p.distance;
        const dy = Math.sin(radians) * p.distance;
        return (
          <span
            key={p.id}
            className="absolute"
            style={{
              width: `${p.size}px`,
              height: `${p.size * 1.6}px`,
              backgroundColor: p.color,
              animation: `confettiBurst ${durationMs}ms ease-out ${p.delay}ms forwards`,
              '--dx': `${dx}px`,
              '--dy': `${dy}px`,
              '--rot': `${p.rot}deg`,
            }}
          />
        );
      })}
    </div>
  );
};

export default Confetti;
